import RunnerSafeType from "../../enums/RunnerSafeType.js";

// @see https://www.theoleballgame.com/is-a-run-scored-on-a-balk-an-earned-run.html
// @see https://baseballrulesacademy.com/official-rule/mlb/9-16-earned-runs-runs-allowed/
// @see https://www.mlb.com/glossary/standard-stats/earned-run
// @see https://www.baseball-reference.com/bullpen/Earned_run
// @see https://baseball.fandom.com/wiki/Earned_run
// An earned run is any run that scores against a pitcher without the benefit of an error or a passed ball. Often, it is the judgment of the official scorer as to whether a specific run would've scored without the defensive mishap. If a pitcher exits a game with runners on base, any earned runs scored by those runners will count against him.
const classifiesAsEarnedRun = function(runnerSafe) {
    switch (runnerSafe) {
        case RunnerSafeType.ThrowingError.key:
        case RunnerSafeType.FieldingError.key:
        case RunnerSafeType.OnPassedBall.key:
        case RunnerSafeType.ExtraRunner.key:
            return false;

        default:
            return true;
    }
};

export default classifiesAsEarnedRun;
